import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

// // // LIST ALL Studios
export const studiosList = (params = '') => Http.get(`/showcase-studios${serialize(params)}`)

export const studioCreate = (params = '') => Http.post('/showcase-studios', params)
export const studioByID = (params = '') => Http.get(`/showcase-studios/${params}?include=showcase,submission,company`)
export const studioUpdate = (params = '') => Http.put(`/showcase-studios/${params.id}`, params)
export const studioDestroy = (params = '') => Http.delete(`/showcase-studios/${params.id}`)
